import { SxProps, Theme } from '@mui/material';
import { TimePicker } from '@mui/x-date-pickers';
import { FC } from 'react';
import { dateToTimeString, timeStringToDate } from 'src/pages/TruckShifts/timeField';

type Props = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: boolean;
  disabled?: boolean;
  sx?: SxProps<Theme>;
};

// 勤務計画の時刻入力。プルダウン（デジタルクロック）は 15 分刻み、キーボード直接入力は
// 1 分単位（15 分刻みでなくてもエラーにしない）、時・分は別セクション。
// 値は 'HH:MM' 文字列で受け渡す（内部で Date に変換）。
// timeSteps はデジタルクロックの刻みのみに効く。minutesStep は validation を伴い
// 手入力が 15 分刻みでないと赤くなるため使わない。
export const TimeSelectField: FC<Props> = ({ label, value, onChange, error, disabled, sx }) => (
  <TimePicker
    label={label}
    value={timeStringToDate(value)}
    onChange={(date) => onChange(dateToTimeString(date))}
    timeSteps={{ minutes: 15 }}
    ampm={false}
    format="HH:mm"
    disabled={disabled}
    slotProps={{ textField: { size: 'small', error, sx } }}
  />
);
